export const BuildingIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <path
        d="M7 25.6663V4.66634C7 4.0475 7.24583 3.45401 7.68342 3.01643C8.121 2.57884 8.71449 2.33301 9.33333 2.33301H18.6667C19.2855 2.33301 19.879 2.57884 20.3166 3.01643C20.7542 3.45401 21 4.0475 21 4.66634V25.6663H7Z"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99967 14H4.66634C4.0475 14 3.45401 14.2458 3.01643 14.6834C2.57884 15.121 2.33301 15.7145 2.33301 16.3333V23.3333C2.33301 23.9522 2.57884 24.5457 3.01643 24.9832C3.45401 25.4208 4.0475 25.6667 4.66634 25.6667H6.99967"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 10.5H23.3333C23.9522 10.5 24.5457 10.7458 24.9832 11.1834C25.4208 11.621 25.6667 12.2145 25.6667 12.8333V23.3333C25.6667 23.9522 25.4208 24.5457 24.9832 24.9832C24.5457 25.4208 23.9522 25.6667 23.3333 25.6667H21"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 7H16.3337"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 11.667H16.3337"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 16.333H16.3337"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.667 21H16.3337"
        stroke="white"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
